import React from 'react'
import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'
import { Hidden } from '@material-ui/core'
import Button from '../Button'
import SVG from '../SVG/SVG'

const useStyles = createUseStyles(theme => ({
    styles: {
        ...theme,
    },

    wrapper: {
        ...theme.wrappers.standard,
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        justifyContent: 'space-between',
        '@media (max-width: 1024px)': {
            flexDirection: 'column',
        },
    },

    footerBar: {
        backgroundColor: theme.colors.sunflower,
        paddingBottom: 30,
        paddingTop: 30,
    },

    footerButton: {
        width: 250,
        '@media (max-width: 1024px)': {
            width: '100%',
            textAlign: 'center',
        },

        '& a': {
            paddingBottom: 12,
            paddingLeft: 30,
            paddingRight: 30,
            paddingTop: 12,
            '&:hover': {
                backgroundColor: theme.colors.marine,
                color: theme.colors.white,
            },
        },
    },

    copyrightInfo: {
        alignItems: 'center',
        display: 'flex',
        flexGrow: 1,
        fontSize: 14,
        justifyContent: 'center',
        letterSpacing: 0.5,
        lineHeight: '16px',
        textAlign: 'center',

        '& a': {
            color: theme.colors.absoluteBlack,
            '&:hover': {
                color: theme.colors.ocean,
            },
        },

        '@media (max-width: 1024px)': {
            margin: '15px 0',
        },
    },

    socialIcons: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        width: 250,
        '& a': {
            '&:hover svg': {
                transform: 'scale(1.125)',
            },
        },
        '@media (max-width: 1024px)': {
            justifyContent: 'center',
            width: '100%',
            textAlign: 'center',
        },

        '& svg': {
            transition: `transform 250ms ${theme.animations.bezier}`,
            marginLeft: 35,
        },
        '& a:first-child svg': {
            marginLeft: 0,
        },
    },
}))

export const FooterBar = ({ children, btnText, btnHref, socialLinks }) => {
    const classes = useStyles()

    return (
        <div className={classes.footerBar}>
            <div className={classes.wrapper}>
                <div className={classes.footerButton}>
                    <Button href={btnHref} fluid={false}>
                        {btnText}
                    </Button>
                </div>
                <div className={classes.copyrightInfo}>
                    <span>{children}</span>
                </div>
                <div className={classes.socialIcons}>
                    {socialLinks.map((link, index) => (
                        <a
                            key={`footer-social-link-${index}`}
                            target="_blank"
                            href={link.href}
                            rel="noreferrer"
                        >
                            <SVG name={link.name} width={35} height={35} colorOne={'#01396c'} />
                        </a>
                    ))}
                </div>
            </div>
        </div>
    )
}

FooterBar.propTypes = {
    children: PropTypes.node,
    btnText: PropTypes.string,
    btnHref: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(undefined)]),
    socialLinks: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            href: PropTypes.string,
        }),
    ),
}

export default FooterBar
